import React from 'react'
import { useEditPermissions, useEditModeState, useEditModeHandlers } from '../../../use-category-roles'
import { getVisibleRoles } from '../../../../helpers'
import EditSectionLayout from './EditSectionLayout'
import type { SingleEditCategorySectionProps } from '../../../../types'

const SingleEditCategorySection: React.FC<SingleEditCategorySectionProps> = ({
  category,
  isInternal = false,
  contact,
  withBorder = false,
  compact = false,
  colorScheme = 'green',
  isRoleEdit = false
}) => {
  const { user } = useEditPermissions()
  if (!category || !user) return null

  const visibleRoles = getVisibleRoles(category, isInternal)
  
  if (visibleRoles.length === 0) return null

  const { roles, allSelected, hasSelection } = useEditModeState(visibleRoles)
  const { handleAddAll, handleReset, handleToggleAll } = useEditModeHandlers(visibleRoles)

  return (
    <EditSectionLayout
      category={category}
      visibleRoles={visibleRoles}
      roles={roles}
      user={user}
      contact={contact ?? null}
      withBorder={withBorder}
      colorScheme={colorScheme}
      compact={compact}
      allSelected={allSelected}
      hasSelection={hasSelection}
      onAddAll={handleAddAll}
      onReset={handleReset}
      onToggleAll={() => handleToggleAll(hasSelection)}
      isRoleEdit={isRoleEdit}
    />
  )
}

export default SingleEditCategorySection